module.exports = __webpack_public_path__ + "static/media/8.b9b3ee9a.png";